module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "rooms_grid"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.rooms), function(room) {
    return _c('div', {
      staticClass: "col-lg-3 col-md-4 col-sm-6"
    }, [_c('div', {
      staticClass: "room_grid_item"
    }, [_c('figure', [_c('router-link', {
      staticClass: "hover_effect h_link h_blue",
      attrs: {
        "to": '/site/room/' + room.id
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": _vm.getImage(room),
        "alt": "Image"
      }
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "room_info"
    }, [_c('h3', [_c('router-link', {
      attrs: {
        "to": '/site/room/' + room.id
      }
    }, [_vm._v("\n                                " + _vm._s(room.name[_vm.currentLanguage]) + "\n                            ")])], 1), _vm._v(" "), (room.price) ? _c('span', [_c('i', {
      staticClass: "text-normal"
    }, [_vm._v("$" + _vm._s(room.price || 0))]), _vm._v(" / "), _c('i', {
      directives: [{
        name: "lang",
        rawName: "v-lang.night",
        modifiers: {
          "night": true
        }
      }],
      staticClass: "text-normal"
    })]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.truncate(room.description[_vm.currentLanguage])))]), _vm._v(" "), (room.services.length > 0) ? _c('div', {
      staticClass: "room_services"
    }, _vm._l((room.services), function(service) {
      return _c('i', {
        class: service.icon
      })
    })) : _vm._e(), _vm._v(" "), _c('router-link', {
      directives: [{
        name: "lang",
        rawName: "v-lang.book__now",
        modifiers: {
          "book__now": true
        }
      }],
      staticClass: "button  btn_blue btn_full upper mt20",
      attrs: {
        "to": '/site/room/' + room.id
      }
    })], 1)])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab3dfef6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/rooms/GridView.vue
// module id = 388
// module chunks = 0